import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { PG_CALLBACK_KEY, writeSession, type PlaygroundCallback } from '@/lib/playground';

/**
 * Redirect target for the playground. Records exactly what authrz.me sent back
 * (code/state or an error) and hands off to the playground's Callback step —
 * the token exchange is a separate, explicit step there.
 */
export function PlaygroundCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const entry: PlaygroundCallback = {
      code: searchParams.get('code'),
      state: searchParams.get('state'),
      error: searchParams.get('error') ?? (searchParams.get('code') ? null : 'missing_code'),
      errorDescription: searchParams.get('error_description'),
      receivedAt: new Date().toISOString(),
      url: `${window.location.origin}${window.location.pathname}`,
    };
    writeSession(PG_CALLBACK_KEY, entry);
    navigate('/playground', { replace: true });
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-[40vh] items-center justify-center" role="status" aria-live="polite">
      <div className="flex items-center gap-2.5 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        Reading the authorization response…
      </div>
    </div>
  );
}
